export enum ChargePackageActionTypes {
    FETCH_CHARGE_PACKAGE_TYPES = '@@payment/FETCH_CHARGE_PACKAGE_TYPES',
    SET_CHARGE_PACKAGE_TYPES = '@@payment/SET_CHARGE_PACKAGE_TYPES',
    SET_PAYMENT_TYPE = '@@payment/SET_PAYMENT_TYPE',
    SET_TRANSACTION_STATUS = '@@payment/SET_TRANSACTION_STATUS'
}

export interface ChargePackageStateInterface {
    readonly info: object
    readonly loading: boolean,
    readonly type: 0 | 1 | 3 | 4,
    readonly status: string
}
